import React from 'react';
import { translate } from 'react-i18next';

import Form from '../create/Form';
import * as API from '../../core/api';
import { catchFormErrors } from '../../utils/form-errors';

class Edit extends React.Component {
  handleSubmit = (formValues) => {
    const { onSuccess, type, project } = this.props;

    const promises = [];
    promises.push(
      API.put(`projects/${project._id}`, {
        ...formValues,
        urls: formValues.urls
          ? formValues.urls.split(',').map((url) => url.trim())
          : [],
        type,
      })
    );

    const isNewAvatarSelected = typeof formValues.logoUrl === 'object';
    if (isNewAvatarSelected) {
      const data = new FormData();
      data.append('avatar', formValues.logoUrl, formValues.logoUrl.name);

      promises.push(API.post(`projects/${project._id}/logo`, data));
    }

    return Promise.all(promises)
      .then(onSuccess)
      .catch(catchFormErrors);
  };

  render() {
    const { project, t } = this.props;

    return (
      <Form
        initialValues={{ ...project, urls: project.urls.join(', ') }}
        okButtonText={t('general.saveChanges')}
        onSubmit={this.handleSubmit}
      />
    );
  }
}

export default translate()(Edit);



// WEBPACK FOOTER //
// ./src/projects/edit/index.js